import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { DialogContent } from "../../base/dialog/dialog";
import { cn } from "../../../utils";
export const DIALOG_SIZES = {
    xs: 380,
    sm: 520,
    md: 680,
    lg: 880,
    xl: 1100
};
export const DialogShell = /*#__PURE__*/ React.forwardRef(function DialogShell({ size = "md", minHeight, className, style, children, ...props }, ref) {
    const width = DIALOG_SIZES[size];
    return /*#__PURE__*/ _jsx(DialogContent, {
        ref: ref,
        hideAutoClose: true,
        className: cn("flex flex-col gap-0 p-0 max-w-none max-h-[92vh] overflow-hidden rounded-2xl bg-white text-foreground shadow-2xl", className),
        style: {
            width,
            maxWidth: "92vw",
            minHeight: minHeight != null ? `min(${minHeight}px, 92vh)` : undefined,
            ...style
        },
        ...props,
        children: children
    });
});

//# sourceMappingURL=DialogShell.js.map